// External libraries
import React from "react";

// Project components
import Button from "../../../../../Components/Button";
import TableLite from "../../../../../Components/TableLite";

/**
 * Table component for displaying and managing custom fields
 * @param {Object} props - Component props
 * @param {Array} props.customFields - Array of custom field objects to display
 * @param {Function} props.onEdit - Callback function when edit button is clicked
 * @param {Function} props.onDelete - Callback function when delete button is clicked
 * @returns {JSX.Element|null} The custom fields table component or null if no custom fields
 */
const CustomFieldsTable = ({ customFields, onEdit, onDelete }) => {
	if (!customFields || customFields.length === 0) {
		return null;
	}

	const columns = [
		{
			id: "name",
			label: "Name",
			getter: (row) => row.name,
		},
		{
			id: "type",
			label: "Type",
			getter: (row) => row.type,
		},
		{
			id: "edit",
			label: "Edit",
			width: "80px",
			getter: (row) => (
				<Button color="blue" size="small" onClick={() => onEdit(row.id)}>
					Edit
				</Button>
			),
		},
		{
			id: "delete",
			label: "Delete",
			width: "80px",
			getter: (row) => (
				<Button color="red" size="small" onClick={() => onDelete(row.id)}>
					Delete
				</Button>
			),
		},
	];

	return <TableLite columns={columns} rows={customFields} />;
};

export default CustomFieldsTable;
